/** Data model functions for the Publisher data-type. */

import DataClass from '../base/data/DataClass';
import C from '../C';

class Publisher extends DataClass {
	constructor(base) {
		super(base);
		Object.assign(this, base);
	}
}
DataClass.register(Publisher, "Publisher");
const This = Publisher;
export default Publisher;
